export class PagedRequest {

	public pageNumber: number;
	public pageSize: number;

	constructor(obj?: any) {
		this.pageNumber = obj && obj.pageNumber || 1;
		this.pageSize = obj && obj.pageSize || 10;
	}
}

export class PagedRequestData extends PagedRequest {
	public data?: any[] = Array<any>();
	public totalItems: number = 0;
	constructor(obj?: any, dataProp?: string) {
		super(obj);
		this.pageSize = obj && obj.pageSize || 10;
		if (dataProp && obj.hasOwnProperty(dataProp)) {
			this.data = obj[dataProp];
		}
	}
}


